import { jsx as _jsx } from "react/jsx-runtime";
import { Text } from "@kolmeo/ui-core";
const BottomTabLabel = ({ focused, color, label }) => {
    return (_jsx(Text, { mt: 1, variant: focused ? "textHeavy10" : "textMedium10", color: color, children: label }));
};
export default BottomTabLabel;
